// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-view-widgets-ProductCartForm-___styles-modules__add-to-cart{border-radius:0 !important;background-color:#333 !important}.src-view-widgets-ProductCartForm-___styles-modules__add-to-cart:hover{background-color:#000 !important}.src-view-widgets-ProductCartForm-___styles-modules__add-to-cart.src-view-widgets-ProductCartForm-___styles-modules__modal{width:100%}", ""]);
// Exports
exports.locals = {
	"add-to-cart": "src-view-widgets-ProductCartForm-___styles-modules__add-to-cart",
	"modal": "src-view-widgets-ProductCartForm-___styles-modules__modal"
};
module.exports = exports;
